import React, { useEffect } from 'react';
import { Route, Redirect, useParams, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { FiltersContextProvider } from '../../filters/context';
import { noop } from 'ui-components/default-props/noop';
import gridPageStyle from '../../pages/grid-page.module.less';
import { BatchesListPageContainer } from '../../containers/batches/batches-list-page-container';
import { ShipmentModalLoader } from '../../components/modals/shipment-details-modal/shipment-modal-loader';
import { resolveRoute } from '../../services/shipment-details-route-resolver';
import OrdersBatches from '../../pages/orders-batches';

import style from './batches-page.module.less';

const BatchesPage = ({ updateShippingPageLeftNav = noop, updatePaging = noop }) => {
  const match = useRouteMatch();
  const { tabFilter } = useParams();
  const { params } = useRouteMatch('/shipments/batches/:tabFilter(open|archived|processed|advanced-search)/:batchId') || {};
  const { batchId } = params || {};

  // this handles initial component mount, components handle themselves after
  useEffect(() => {
    updateShippingPageLeftNav(tabFilter);
    updatePaging(!!batchId);
    // oxlint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FiltersContextProvider>
      <div className={classnames(gridPageStyle['main-content'], style['main-content'])}>
        <div
          className={classnames(style['batches-page-wrappers'], {
            [style['detail-page-in']]: !!batchId,
          })}
        >
          <Route
            path='/shipments/batches/:tabFilter'
            render={({ history }) => (
              <div className={style['list-page']}>
                <BatchesListPageContainer batchId={batchId} history={history} match={match} />
              </div>
            )}
          />
          <Route
            path='/shipments/batches/:tabFilter(open|archived|processed|advanced-search)/:batchId'
            render={() => (
              <div className={style['detail-page']}>
                <OrdersBatches className={style['open-batch-details-page']} returnUrl={`/shipments/batches/${tabFilter}`} />
              </div>
            )}
          />
        </div>
        <Route component={ShipmentModalLoader} path={`${match.path}/shipment/:fulfillmentPlanId`} />
        <Route component={ShipmentModalLoader} path={resolveRoute(match.url)} />
        {!tabFilter && <Redirect exact from='/shipments/batches' strict to='/shipments/batches/open' />}
      </div>
    </FiltersContextProvider>
  );
};

BatchesPage.propTypes = {
  updateShippingPageLeftNav: PropTypes.func,
  updatePaging: PropTypes.func,
};

export default BatchesPage;
